// extracted by mini-css-extract-plugin
module.exports = {"root":"CheckedCell_root__2DHpA"};